import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * Inline SVG logo mark + wordmark. Stays crisp at any size.
 */
export function Logo({
  size = 36,
  compact = false,
}: {
  size?: number;
  compact?: boolean;
}) {
  return (
    <Box
      component={RouterLink}
      to="/"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        textDecoration: "none",
        "&:hover": { textDecoration: "none" },
      }}
      aria-label="ChikitsaLink — home"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 220 220"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <defs>
          <linearGradient id="lgBg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2E7D32" />
            <stop offset="100%" stopColor="#1B5E20" />
          </linearGradient>
          <linearGradient id="lgHeart" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="100%" stopColor="#E8F5E9" />
          </linearGradient>
        </defs>
        <rect x="10" y="10" width="200" height="200" rx="48" fill="url(#lgBg)" />
        <rect
          x="18"
          y="18"
          width="184"
          height="184"
          rx="42"
          fill="none"
          stroke="#A5D6A7"
          strokeOpacity={0.35}
          strokeWidth={2}
        />
        <path
          d="M110 74 c-18 -28 -58 -24 -58 10 c0 28 38 48 58 64 c20 -16 58 -36 58 -64 c0 -34 -40 -38 -58 -10 Z"
          fill="url(#lgHeart)"
        />
        <g fill="none" stroke="#1B5E20" strokeWidth={5} strokeLinecap="round">
          <path d="M76 90 C70 110, 78 128, 96 134" />
          <path d="M144 90 C150 110, 142 128, 124 134" />
          <circle cx={76} cy={88} r={5} fill="#1B5E20" />
          <circle cx={144} cy={88} r={5} fill="#1B5E20" />
          <path d="M110 134 L110 152" strokeWidth={5} />
        </g>
        <circle cx={110} cy={158} r={10} fill="#1B5E20" />
        <circle cx={110} cy={158} r={5} fill="#81C784" />
        <g fill="none" strokeWidth={6} strokeLinecap="round">
          <rect x={56} y={170} width={54} height={22} rx={11} stroke="#FFFFFF" />
          <rect x={94} y={170} width={54} height={22} rx={11} stroke="#F57C00" />
        </g>
      </svg>
      {!compact && (
        <Box sx={{ lineHeight: 1 }}>
          <Typography
            component="span"
            sx={{
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 800,
              fontSize: size * 0.6,
              letterSpacing: "-0.5px",
              color: "primary.dark",
            }}
          >
            Chikitsa
            <Box component="span" sx={{ color: "warning.main" }}>
              Link
            </Box>
          </Typography>
          <Typography
            component="div"
            sx={{
              fontSize: size * 0.22,
              letterSpacing: "3px",
              color: "primary.main",
              fontWeight: 500,
              mt: 0.25,
            }}
          >
            CONNECT · CONSULT · CARE
          </Typography>
        </Box>
      )}
    </Box>
  );
}
